import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { duration } from "moment/moment";
import SelectMultiple from "react-select";
import { MultiSelect } from "react-multi-select-component";
import Select2 from "react-select";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../constants";
import axios2 from "axios";
import ProgressBar from "../../Components/ProgressBar";
import CourseLoader from "../../Components/CourseLoader";

const AddEditCourse = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isSavingCourse, setIsSavingCourse] = useState(false);
  const editor = useRef(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isVideoUploading, setIsVideoUploading] = useState(false);
  const [progressNumber, setProgressNumber] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [optionsSchools, setOptionsSchools] = useState([]);
  const [optionsClasses, setOptionsClasses] = useState([]);
  const [optionsSubjects, setOptionsSubjects] = useState([]);

  const [optionsUniversities, setOptionsUniversities] = useState([]);
  const [item, setItem] = useState({
    titleAr: "",
    titleEn: "",
    nameAr: "",
    nameEn: "",
    descriptionEn: "",
    descriptionAr: "",
    isActive: true,
    price: "",
    duration: "",
    professors: "",
    type: "",
    school: "",
    university: "",
    class: "",
    subject: "",
    preview: "",
  });
  const handleSelectChangeSchool = (newValue) => {
    console.log(newValue);
    setItem({ ...item, school: newValue });
  };
  const handleSelectChangeClass = (newValue) => {
    setItem({ ...item, class: newValue });
    setClassError("");
  };
  const [classError, setClassError] = useState("");
  const handleSelectChangeSubject = (newValue) => {
    setItem({ ...item, subject: newValue });
    setSubjectError("");
  };
  const [subjectError, setSubjectError] = useState("");

  const handleSelectChangeUniversity = (newValue) => {
    setItem({ ...item, university: newValue });
  };

  const [schoolUniversityError, setSchoolUniversityError] = useState("");
  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });
    setTypeError("");
  };
  const [typeError, setTypeError] = useState("");
  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
    setPriceError("");
  };
  const [priceError, setPriceError] = useState("");
  const handleChangeDuration = (newValue) => {
    setItem({ ...item, duration: newValue });
    setDurationError("");
  };
  const [durationError, setDurationError] = useState("");
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameError("");
  };
  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameError("");
  };
  const [nameError, setNameError] = useState("");
  const handleChangeTitleEn = (newValue) => {
    setItem({ ...item, titleEn: newValue });
    setTitleEnError("");
  };
  const [titleEnError, setTitleEnError] = useState("");

  const handleChangeTitleAr = (newValue) => {
    setItem({ ...item, titleAr: newValue });
    setTitleArError("");
  };
  const [titleArError, setTitleArError] = useState("");

  const handleChangeDescriptionEn = (newValue) => {
    setItem({ ...item, descriptionEn: newValue });
    setDescriptionEnError("");
  };
  const [descriptionEnError, setDescriptionEnError] = useState("");
  const handleChangeDescriptionAr = (newValue) => {
    setItem({ ...item, descriptionAr: newValue });
    setDescriptionArError("");
  };
  const [descriptionArError, setDescriptionArError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);
  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts pngs and jpegs"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const [selectedProfessors, setSelectedProfessors] = useState([]);
  const [professorsError, setProfessorsError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    let responseProfessors = [];
    let responseSchools = [];
    let responseUniversities = [];
    try {
      responseProfessors = await axios.get(`/professors`);
      setOptionsProfessors(
        responseProfessors.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseSchools = await axios.get(`/schools`);
      setOptionsSchools(
        responseSchools.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseUniversities = await axios.get(`/universities`);
      setOptionsUniversities(
        responseUniversities.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props.type === "edit") {
      try {
        responseItem = await axios.get(`/courses/${id}`);
        setItem({
          type:
            responseItem?.data?.data?.type &&
            responseItem?.data?.data?.type?.id !== null
              ? String(responseItem.data.data.type?.id)
              : "",
          university:
            String(responseItem.data.data.type?.id) === "2" &&
            responseItem?.data?.data?.university !== null
              ? {
                  label: getFirstNonNullValue(
                    responseItem?.data?.data?.university?.name
                  ),
                  value: String(responseItem?.data?.data?.university?.id),
                }
              : "",

          subject: responseItem?.data?.data?.subject
            ? {
                label: getFirstNonNullValue(
                  responseItem?.data?.data?.subject?.name
                ),
                value: String(responseItem?.data?.data?.subject?.id),
              }
            : "",

          class:
            String(responseItem.data.data.type?.id) === "1" &&
            responseItem?.data?.data?.school_class !== null
              ? {
                  label: getFirstNonNullValue(
                    responseItem?.data?.data?.school_class?.name
                  ),
                  value: String(responseItem?.data?.data?.school_class?.id),
                }
              : "",

          school:
            String(responseItem.data.data.type?.id) === "1" &&
            responseItem?.data?.data?.school
              ? {
                  label: getFirstNonNullValue(
                    responseItem?.data?.data?.school?.name
                  ),
                  value: String(responseItem?.data?.data?.school?.id),
                }
              : "",
          nameEn:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.en
              ? responseItem.data.data.name.en
              : "",
          nameAr:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.ar
              ? responseItem.data.data.name.ar
              : "",
          descriptionEn:
            responseItem?.data?.data?.description &&
            responseItem?.data?.data?.description?.en
              ? responseItem.data.data.description.en
              : "",
          descriptionAr:
            responseItem?.data?.data?.description &&
            responseItem?.data?.data?.description?.ar
              ? responseItem.data.data.description.ar
              : "",
          titleEn:
            responseItem?.data?.data?.title &&
            responseItem?.data?.data?.title?.en
              ? responseItem.data.data.title.en
              : "",
          titleAr:
            responseItem?.data?.data?.title &&
            responseItem?.data?.data?.title?.ar
              ? responseItem.data.data.title.ar
              : "",
          image: responseItem?.data?.data?.image
            ? responseItem.data.data.image
            : "",
          price:
            responseItem?.data?.data?.price !== null
              ? String(responseItem.data.data.price)
              : "",
          // duration:
          //   responseItem?.data?.data?.time !== null
          //     ? String(responseItem.data.data.time)
          //     : "",
          preview: responseItem?.data?.data?.preview_video
            ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
            : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
        });
        setSelectedProfessors(
          responseItem?.data?.data?.professors?.map((item, index) => {
            return {
              label: getFirstNonNullValue(item.name),
              value: String(item.id),
            };
          })
        );
      } catch (error) {
        console.log(error);
      }
    }

    setIsSaving(false);
  }

  // useEffect(() => {
  //   props.type === "edit" &&
  //     axios
  //       .get(`/courses/${id}`)
  //       .then((result) => {
  //         console.log(result.data.data);
  //         setItem({
  //           nameEn:
  //             result?.data?.data?.name && result?.data?.data?.name?.en
  //               ? result.data.data.name.en
  //               : "",
  //           nameAr:
  //             result?.data?.data?.name && result?.data?.data?.name?.ar
  //               ? result.data.data.name.ar
  //               : "",
  //           descriptionEn:
  //             result?.data?.data?.description &&
  //             result?.data?.data?.description?.en
  //               ? result.data.data.description.en
  //               : "",
  //           descriptionAr:
  //             result?.data?.data?.description &&
  //             result?.data?.data?.description?.ar
  //               ? result.data.data.description.ar
  //               : "",
  //           titleEn:
  //             result?.data?.data?.title && result?.data?.data?.title?.en
  //               ? result.data.data.title.en
  //               : "",
  //           titleAr:
  //             result?.data?.data?.title && result?.data?.data?.title?.ar
  //               ? result.data.data.title.ar
  //               : "",
  //           image: result?.data?.data?.image ? result.data.data.image : "",
  //           isActive: result?.data?.data?.is_active ? true : false,
  //         });
  //         setIsSaving(false);
  //       })

  //       .catch((err) => console.log(err));
  // }, []);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const previewKey = useRef("");

  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };

  const [filesPreview, setFilesPreview] = useState([]);
  const handleDropZonePreview = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesPreview((filesPreview) => [...filesPreview, ...filesPreview]),
    []
  );
  const fileUploadPreview = !filesPreview.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4 and mov"} />
  );
  const uploadedFilesPreview = filesPreview.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesPreview[filesPreview.length - 1].type)
              ? window.URL.createObjectURL(
                  filesPreview[filesPreview.length - 1]
                )
              : NoteIcon
          }
        />
        <div>
          {filesPreview[filesPreview.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesPreview[filesPreview.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendPreview = (filesPreview) => {
    setIsVideoUploading(true);
    let url2 = "";
    const form_data = new FormData();
    form_data.append("file_name", filesPreview[filesPreview.length - 1].name);
    form_data.append(
      "content_type",
      filesPreview[filesPreview.length - 1].type
    );
    axios
      .post("/generate-presigned-url", form_data)
      .then((res) => {
        previewKey.current = res.data.key;
        url2 = res.data.url;

        axios2
          .put(url2, filesPreview[filesPreview.length - 1], {
            headers: {
              "Content-Type": filesPreview[filesPreview.length - 1].type,
            },
            onUploadProgress: (progressEvent) => {
              // Calculate the percentage of upload progress
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Upload progress: ${percentCompleted}%`);
              setProgressNumber(`${percentCompleted}`);
              // You can also update a state here if you are using React for a progress bar
              // setUploadProgress(percentCompleted);
            },
          })
          .then((res) => {
            setIsVideoUploading(false);
            setItem({
              ...item,
              preview:
                validImageTypes.indexOf(
                  filesPreview[filesPreview.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      filesPreview[filesPreview.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            });
          })
          .catch((error) => {
            if (error.response) {
              console.error("Status:", error.response.status);
              console.error(
                "Headers:",
                JSON.stringify(error.response.headers, null, 2)
              );
              console.error("Data:", error.response.data);
            } else {
              console.error("Error Message:", error.message);
            }
          });
      })
      .catch((err) => console.log(""));
  };
  useEffect(() => {
    item.type === "1" &&
      axios
        .get(`/classes?filter[schools.id]=${item.school.value}`)
        .then((result) => {
          setOptionsClasses(
            result.data.data.data.map((item, index) => {
              return {
                label: item?.name && getFirstNonNullValue(item.name),
                value: String(item.id),
              };
            })
          );
        })

        .catch((err) => console.log(err));
  }, [item?.school?.value]);
  useEffect(() => {
    item.type === "1" &&
      axios
        .get(`/subjects?filter[schoolClasses.id]=${item.class.value}`)
        .then((result) => {
          setOptionsSubjects(
            result.data.data.data.map((item, index) => {
              return {
                label: item?.name && getFirstNonNullValue(item.name),
                value: String(item.id),
              };
            })
          );
        });
  }, [item?.class?.value]);

  useEffect(() => {
    item.type === "2" &&
      axios
        .get(`/subjects?filter[universities.id]=${item.university.value}`)
        .then((result) => {
          setOptionsSubjects(
            result.data.data.data.map((item, index) => {
              return {
                label: item?.name && getFirstNonNullValue(item.name),
                value: String(item.id),
              };
            })
          );
        });
  }, [item?.university?.value]);

  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/courses/${id}`)
      .then((result) => {
        navigate("/admin/courses");
      })
      .catch((err) => console.log(err));
  };
  const [error, setError] = useState("");
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Course`}
      backAction={{
        onAction: () => navigate(`/admin/courses`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <Select
            label="Type"
            options={[
              { label: "School", value: "1" },
              { label: "University", value: "2" },
            ]}
            onChange={handleSelectChangeType}
            value={item.type}
            placeholder="Please select"
            error={typeError}
            requiredIndicator
          />
          {item.type === "1" ? (
            <FormLayout.Group>
              <FormLayout>
                <Text>School</Text>
                <Select2
                  options={optionsSchools}
                  onChange={handleSelectChangeSchool}
                  value={item.school}
                  placeholder="Please select a school"
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
              </FormLayout>
              <FormLayout>
                <Text>Class</Text>
                <Select2
                  options={optionsClasses}
                  onChange={handleSelectChangeClass}
                  value={item.class}
                  placeholder="Please select a class"
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
                <InlineError message={classError} />
              </FormLayout>
              <FormLayout>
                <Text>Subject</Text>
                <Select2
                  options={optionsSubjects}
                  onChange={handleSelectChangeSubject}
                  value={item.subject}
                  placeholder="Please select a subject"
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
                <InlineError message={subjectError} />
              </FormLayout>
            </FormLayout.Group>
          ) : item.type === "2" ? (
            <FormLayout.Group>
              <FormLayout>
                <Text>University</Text>
                <Select2
                  options={optionsUniversities}
                  onChange={handleSelectChangeUniversity}
                  value={item.university}
                  placeholder="Please select a university"
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
              </FormLayout>
              <FormLayout>
                <Text>Subject</Text>
                <Select2
                  options={optionsSubjects}
                  onChange={handleSelectChangeSubject}
                  value={item.subject}
                  placeholder="Please select a subject"
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
                <InlineError message={subjectError} />
              </FormLayout>
            </FormLayout.Group>
          ) : null}
          <InlineError message={schoolUniversityError} />
          {/* <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
            />
          </FormLayout.Group> */}
          <InlineError message={nameError} />
          <FormLayout.Group>
            <TextField
              value={item.titleEn}
              onChange={handleChangeTitleEn}
              label="Title En"
              requiredIndicator
              error={titleEnError}
            />
            <TextField
              value={item.titleAr}
              onChange={handleChangeTitleAr}
              label="Title Ar"
              align="right"
              requiredIndicator
              error={titleArError}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Price (KWD)"
              options={[
                { label: "0", value: "0" },
                { label: "5", value: "5" },
                { label: "10", value: "10" },
                { label: "15", value: "15" },
                { label: "20", value: "20" },
                { label: "25", value: "25" },
                { label: "30", value: "30" },
                { label: "35", value: "35" },
                { label: "40", value: "40" },
                { label: "45", value: "45" },
                { label: "50", value: "50" },
                { label: "55", value: "55" },
                { label: "60", value: "60" },
              ]}
              onChange={handleChangePrice}
              value={item.price}
              placeholder="Please select"
              requiredIndicator
              error={priceError}
            />
            {/* <TextField
              value={item.price}
              onChange={handleChangePrice}
              label="Price"
              type="number"
              error={priceError}
              requiredIndicator
            /> */}
            {/* <TextField
              value={item.duration}
              onChange={handleChangeDuration}
              label="Duration"
              suffix="seconds"
              error={durationError}
              requiredIndicator
            /> */}
          </FormLayout.Group>

          <Text>Description</Text>
          <JoditEditor
            ref={editor}
            value={item.descriptionEn}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescriptionEn}
          />
          <InlineError message={descriptionEnError} />
          {/* <Editor
            apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
            value={item.descriptionEn}
            init={{
              branding: false,
              height: 200,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help|code",
            }}
            onEditorChange={handleChangeDescriptionEn}
          /> */}

          <Text>Description Ar</Text>
          <JoditEditor
            ref={editor}
            value={item.descriptionAr}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescriptionAr}
          />
          <InlineError message={descriptionArError} />
          {/* <Editor
            apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
            value={item.descriptionAr}
            init={{
              branding: false,
              height: 200,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help|code",
            }}
            onEditorChange={handleChangeDescriptionAr}
          /> */}
          <Text>Professors</Text>
          <div style={{ position: "relative", zIndex: 9999 }}>
            <MultiSelect
              options={optionsProfessors}
              onChange={setSelectedProfessors}
              value={selectedProfessors}
              placeholder="Please select"
            />
          </div>
          <InlineError message={professorsError} />
          <Text>
            Image <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".jpeg,.png,.jpg"
                onDrop={handleDropZone}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />
          <Text>Preview Video</Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail
                size="large"
                source={item.preview ? item.preview : ""}
              />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".mp4,.mov"
                onDrop={handleDropZonePreview}
                allowMultiple={false}
                onDropAccepted={sendPreview}
              >
                {uploadedFilesPreview}
                {fileUploadPreview}
              </DropZone>
            </div>
          </div>
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />
      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/courses/${id}`)
                  .then((result) => {
                    navigate(`/admin/courses`);
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
      {isVideoUploading ? <ProgressBar progress={progressNumber} /> : null}
      {isSavingCourse ? <CourseLoader /> : null}
    </Page>
  );

  function handleSave() {
    console.log(selectedProfessors);
    if (
      // (!item.nameEn && !item.nameAr) ||
      (!files?.length && props?.type === "add") ||
      // !selectedProfessors.length ||
      !item.titleEn ||
      !item.titleAr ||
      item.type === "" ||
      (item.type === "1" && item.school === "") ||
      (item.type === "2" && item.university === "") ||
      (item.type === "1" && item.class === "") ||
      ((item.type === "1" || item.type === "2") && item.subject === "") ||
      !item.price
      // !item.duration ||
      // !item.descriptionEn ||
      // !item.descriptionAr
    ) {
      !item.titleEn && setTitleEnError("This field is required");
      !item.titleAr && setTitleArError("This field is required");
      // !item.nameEn && !item.nameAr && setNameError("Please enter a name");
      !files?.length &&
        props?.type === "add" &&
        setImageError("Please upload an image");
      // !selectedProfessors.length &&
      //   setProfessorsError("Please select ad least one professor");
      item.type === "" && setTypeError("Please enter a type");
      (item.type === "1" && item.school === "") ||
        (item.type === "2" &&
          item.university === "" &&
          setSchoolUniversityError("Please select an option"));
      item.type === "1" &&
        item.class === "" &&
        setClassError("Please select an option");
      (item.type === "1" || item.type === "2") &&
        item.subject === "" &&
        setSubjectError("Please select an option");
      !item.price && setPriceError("This field is required");
      // !item.duration && setDurationError("This field is required");
      // !item.descriptionEn && setDescriptionEnError("This field is required");
      // !item.descriptionAr && setDescriptionArError("This field is required");
    } else {
      setIsSaving(true);
      setIsSavingCourse(true);
      const form_data = new FormData();
      form_data.append("type", item.type);
      item.type === "1" && form_data.append("school_id", item.school.value);
      item.type === "1" &&
        form_data.append("school_class_id", item.class.value);
      item.type === "2" &&
        form_data.append("university_id", item.university.value);
      form_data.append("subject_id", item.subject.value);
      form_data.append("price", item.price);
      // form_data.append("time", item.duration);
      // item.nameEn && form_data.append("name[en]", item.nameEn);
      // item.nameAr && form_data.append("name[ar]", item.nameAr);
      item.titleEn && form_data.append("title[en]", item.titleEn);
      item.titleAr && form_data.append("title[ar]", item.titleAr);
      item.descriptionEn &&
        form_data.append("description[en]", item.descriptionEn);
      item.descriptionAr &&
        form_data.append("description[ar]", item.descriptionAr);
      files?.length && form_data.append("image", files[0]);
      form_data.append("is_active", item.isActive ? 1 : 0);
      selectedProfessors.forEach((selectedProfessor, index) =>
        form_data.append(`professor_ids[${index}]`, selectedProfessor.value)
      );
      previewKey.current &&
        form_data.append("preview_video", previewKey.current);
      // item.type === "2" && form_data.append("university_id", item.university);
      // item.type === "1" && form_data.append("school_id", item.school);
      // item.type === "1" && form_data.append("class_id", item.class);
      // form_data.append("subject_id", item.subject);
      props?.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/courses`, form_data)
            .then((result) => {
              navigate(`/admin/courses`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/courses/${id}`, form_data)
            .then((result) => {
              navigate(`/admin/courses`);
              // toggleActive();
              // setIsSaving(false);
              // setIsSavingCourse(false);
            })
            .catch((error) => {
              setIsSavingCourse(false);
              setIsSaving(false);
              console.log("error=", error.response.data.message);
              setError(error.response.data.message);
            });
    }
  }

  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditCourse;
